import { render } from "./ImportColisStock.vue?vue&type=template&id=aade60dc&scoped=true&ts=true"
import script from "./ImportColisStock.vue?vue&type=script&lang=ts"
export * from "./ImportColisStock.vue?vue&type=script&lang=ts"

import "./ImportColisStock.vue?vue&type=style&index=0&id=aade60dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aade60dc"]])

export default __exports__